import * as React from "react"
import { clx } from "../utils/clx"
import { inputBaseStyles } from "./input"

// className="block bg-transparent txt-base-regular leading-6 placeholder:text-grey-40"

// placehoder:placeholder-ui-fg-muted ?

/**
 * This component is based on the `textarea` element and supports all of its props
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentPropsWithoutRef<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={clx(
        inputBaseStyles,
        "block txt-base-regular px-3 py-1.5 resize-none",
        className
      )}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
